export default "__VITE_ASSET__Ixl76mkg__"